/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {connect} from 'react-redux'
import { browserHistory } from 'react-router'
import { Dialog } from 'react-weui'
import MainItemTitle from './MainItemTitle'
import MainItemList from './MainItemList'
import MainItemBlock from './MainItemBlock'
import {isPC, isLZWKAPP} from '../../utils'
import config from '../../config'
import ChannelNonePic from '../../images/liveroomSetting/liveroom-setting-channel-none.png'
import LecNonePic from '../../images/liveroomSetting/liveroom-setting-lec-none.png'
import SliderEntry from '../../images/liveroomSetting/liveroom-setting-slider.png'
import SlideGif from '../../images/liveroomSetting/liveroom-setting-slider-gif.gif'
import SchdulePic from '../../images/liveroomSetting/liveroom-setting-schdule.png'

class MainContent extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowScheduleTip: false
        }
    }
    render() {
        const {liveroomInfo} = this.props.liveroomSetting;

        let channelBtn = {
            img: ChannelNonePic,
            text: '创建专栏',
            color: '#4EA8EC',
            method: () => {
                location.assign(`/liveroom/${liveroomInfo.liveroom.id}/edit/channel`)
            }
        };

        if (liveroomInfo.stats_info.channel_count > 0){
            channelBtn = {
                img: ChannelNonePic,
                text: '专栏管理',
                color: '#4EA8EC',
                iconText: liveroomInfo.stats_info.channel_count,
                method: () => {
                    location.assign(`/liveroom/${liveroomInfo.liveroom.id}/edit/channel`)
                }
            };
        }

        let lectureBtn = {
            img: LecNonePic,
            text: '创建课程',
            color: '#F2725D',
            method: () => {
                location.assign(`/liveroom/${liveroomInfo.liveroom.id}/edit/lecture`)
            }
        };

        if (liveroomInfo.stats_info.lecture_count > 0){
            lectureBtn = {
                img: LecNonePic,
                text: '课程管理',
                color: '#F2725D',
                iconText: liveroomInfo.stats_info.lecture_count,
                method: () => {
                    location.assign(`/liveroom/${liveroomInfo.liveroom.id}/edit/lecture`)
                }
            };
        }

        let slideBtn = {
            img: SliderEntry,
            text: '轮播图',
            method: () => {
                if (isPC()){
                    window.open(config.ADMIN_BASE_URL + 'config')
                }else {
                    let text = () => {
                        return (
                            <div>
                                <img src={SlideGif} alt=""/>
                                <p style={{textAlign: 'left', marginTop: '20px'}}>
                                    电脑浏览器打开讲师管理后台（{config.ADMIN_BASE_URL}）在直播间管理中可上传轮播图
                                </p>
                            </div>
                        )
                    };
                    this.context.page.showAlert(text(), '','直播间轮播图');
                }
            }
        };

        const schduleBtn = {
            img: SchdulePic,
            text: '打卡活动',
            method: () => {
                if (isPC()) {
                    window.open('/pc/schedule/list')
                } else {
                    this.setState({ isShowScheduleTip: true })
                }
            }
        }

        return (
            <div className="mianpage-content">
                <MainItemTitle content={'内容'}/>

                <MainItemList>
                    <MainItemBlock blockContent={channelBtn} nopic={liveroomInfo.stats_info.channel_count > 0}/>
                    <MainItemBlock blockContent={lectureBtn} nopic={liveroomInfo.stats_info.lecture_count > 0}/>
                    <MainItemBlock blockContent={slideBtn}/>
                    {
                        !isLZWKAPP() && <MainItemBlock blockContent={schduleBtn} />
                    }
                </MainItemList>
                <Dialog type="ios" title='温馨提示' buttons={[{
                    label: '好',
                    onClick: e => this.setState({ isShowScheduleTip: false })
                }]} show={this.state.isShowScheduleTip}>
                    电脑浏览器打卡讲师管理后台（{config.ADMIN_BASE_URL}），点击【营销中心】-【打卡管理】
                </Dialog>
            </div>
        )
    }
}

MainContent.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(MainContent)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainContent.js